import { getRequest } from '../api-handler';
import { ParameterSetDetailDto } from './parameterset';

export const ParameterSetApi = {
  getById: (id: number) =>
    getRequest<ParameterSetDetailDto>(`/parametersets/${id}`)
};
